import { Flow } from "@/types/app/flow";
import CodePreview from "../Code/CodePreview";

export const FlowVersionDetails = ({ version }: { version: Flow }) => {
  return (
    <dl className="flex h-full w-full flex-col items-start">
      <div className="flex w-full flex-col gap-24">
        <div className="text-14-14 font-bold text-text-base-1">Flow Definition</div>
        <div className="rounded bg-oldgray-100 text-11-16">
          <CodePreview showLineNumbers language="json">
            {JSON.stringify(version.attributes, null, 2)}
          </CodePreview>
        </div>
      </div>
    </dl>
  );
};
